import { parseSlideData, parseSliderConfig, startSliderAutoplay } from './slider';

require('owl.carousel');

const SLIDER_ROOT_KEY = 'history-slider';
const SLIDER_SLIDE_KEY = 'slide';
const SLIDER_TYPE = 'history';
let SLIDER_INDEX = 0;

export default class HistorySliderComponent {
  init() {
    jQuery(SLIDER_ROOT_KEY).each((i, el) => {
      this.render(el);
    });

    return this;
  }

  /**
   * Renders the History Slider
   * @param {HTMLElement} sliderElement
   */
  render(sliderElement) {
    SLIDER_INDEX = 1 + SLIDER_INDEX;
    const xml = sliderElement.outerHTML;
    const config = parseSliderConfig(sliderElement, SLIDER_TYPE);
    const sliderDom = jQuery(
      `<div class="slider history-slider owl-carousel owl-theme" id="history-slider--${SLIDER_INDEX}" />`,
    );

    jQuery(xml)
      .children(SLIDER_SLIDE_KEY)
      .each((j, slide) => {
        const data = parseSlideData(slide, SLIDER_TYPE);
        sliderDom.append(`
          <div class="slider__slide">
            <div class="slider__header">
              <div class="slider__year">${data.year}</div>
            </div>
            <div class="slider__content">
              ${
                data.aumLabel && data.aumValue
                  ? `<span class="slider__aum-value">${data.aumValue}</span>
                    <span class="slider__aum-label">${data.aumLabel}</span>`
                  : ``
              }

              ${data.rows.map((r) => `<div class="slider__row">${r}</div>`).join('')}

            </div>
          </div>
        `);
      });
    jQuery(sliderElement).replaceWith(sliderDom);
    startSliderAutoplay(sliderDom);
    sliderDom.owlCarousel(config);
  }
}
